import React from 'react';

const Popup = ({
  show,
  title,
  corps,
  handlePopupClose
}) => (
  <div className="popup" style={{ display: show ? 'flex' : 'none' }}>
    <div className="popup-content">
      <div className="popup-header">
        <div
          className="cross"
          onClick={handlePopupClose}
        />
        <div className="title"><span>{title}</span></div>
      </div>
      <div
        className="corps"
        onScroll={e => e.stopPropagation()}
        onTouchStart={e => e.stopPropagation()}
        onTouchEnd={e => e.stopPropagation()}
        onTouchMove={e => e.stopPropagation()}
      ><p>{corps}</p></div>
    </div>
  </div>
)

export default Popup;



// WEBPACK FOOTER //
// ./src/views/components/Popup.js